(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$window', '$location', '$stateParams', 'common', 'dataservice', 'bootstrap.dialog', 'backendHubProxy', 'signalrEndPoint'];
    /* @ngInject */
    function LoginController($window, $location, $stateParams, common, dataservice, bsDiag, backendHubProxy, signalrEndPoint) {
        var vm = this;
        vm.title = 'Login';
        vm.submitForm = submitForm;
        vm.data = { "grant_type": "password" };
        vm.promoHtml = '';
        vm.forgotPassword = forgotPassword;
        vm.externalAuthProvider = externalAuthProvider;
        vm.externalLoginComplete = externalLoginComplete;
        vm.loginButtonText = "Login";
        vm.passwordKeyPress = passwordKeyPress;
        vm.manualLogin = manualLogin;
        vm.forceSso = false;
        vm.loadingSso = false;
        vm.loginProviders = [];

        /*
        vm.testAuto = function () {


            dataservice.getItem('api/NotesReport/TestAuto').then(function (res) {
                console.log(res);
            },
                function (res) {
                    console.log(res);

                }
            );
        }
        */
        

        activate();

        function activate() {
            
            backendHubProxy.stop();
            common.notifier.notify(common.config.events.authenticationChange);
            var promises = [getPromo()];
            
            if ($location.host() !== "www.7pointops.com") {
                vm.loadingSso = true;
                promises.push(getLoginProvidersForHost());
            }
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                document.getElementById("userName").focus();
            }, function (error) { });
           
        }

        function getLoginProvidersForHost() {
            return dataservice.getItem("api/Tenants/getLoginProvidersForHost")
                .then(function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.loginProviders = response.data;
                        vm.loadingSso = false;
                        vm.forceSso = response.data[0].ForceSso === "True";
                    }
                    else {
                        vm.loadingSso = false;
                        common.logger.warn("No SSO data found for custom host");
                    }
                }, function (error) { });

        }

        function externalLoginComplete(fragment) {
            if (fragment.error) {
                common.logger.error(fragment.error);
            }
            else {
                common.userService.getAccessToken(fragment, loginSuccess, loginError);
            }
        }

        function forgotPassword() {
            bsDiag.confirmationDialog("Forgot your password", "", "Send Email",
                "Cancel", 'app/dialogs/_passwordResetEmail.html').then(function (result) {

            }, function (diagDismissed) {
                
            });
        }

        function passwordKeyPress(e) {
            if (e.keyCode === 13) {
                if (vm.data.userName && vm.data.password) {
                    vm.submitForm(true);
                }
            }
        }


        function getPromo() {
            return dataservice.getItem("api/Promos/1")
                .then(function (response) {
                    vm.promoHtml = response.data.Html;

                }, function (error) { });
        }
    

        function submitForm(isValid) {
            if (isValid) {
                common.userService.login(vm.data, loginSuccess, loginError);
            }
        }

        function externalAuthProvider(provider) {
            var externalProviderUrl = "https://" + provider.HostName + "/api/Account/ExternalLogin/?provider=" + provider.LoginProvider;               
            
            window.$7PointAuthScope = vm;
            var oauthWindow = window.open(externalProviderUrl, "Authenticate Account", "status=0,width=600,height=750");
        }

        function manualLogin() {
            common.userService.login(vm.data, loginSuccess, loginError);
        }

         
        function loginSuccess() {
            if ($stateParams.returnUrl) {
                common.$location.path($stateParams.returnUrl);
            }
            else {
                common.$location.path('/');
            }
        }

        function loginError(msg) {
            vm.loginErrorMsg = msg;
        }

    }
})();
